import {
  Component,
  OnInit,
  Input,
  ViewContainerRef,
  Renderer2,
  OnDestroy,
  ElementRef,
  HostListener
} from '@angular/core';
import {TrelloChecklist} from '../../../../trello-misc/data/trello-checklist';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {
  ProjectWindowComponent
} from 'projects/desktop/src/app/modules/project/view/project-window/project-window.component';
import {TrelloCheckItem} from '../../../../trello-misc/data/trello-check-item';
import {ProjectService} from '../../../data/project/project.service';
import {TrelloService} from '../../../../trello-misc/data/trello.service';
import {User} from 'projects/core/src/lib/login/data/user';
import {UserService} from 'projects/core/src/lib/login/data/user.service';
import {WsService} from '../../../../data/ws.service';
import {WsUpdateResponce} from '../../../../data/ws-update-responce';
import {trackEntityById} from 'projects/core/src/public-api';
import {
  TasksListDialogComponent
} from 'projects/desktop/src/app/modules/home-page/view/home-board/dash-board-main-block/task-column/tasks-list-dialog/tasks-list-dialog.component';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {CheckItemHeadTag} from '../../../../trello-misc/data/checkitem-head-tag';
import {Task} from 'projects/desktop/src/app/modules/home-page/data/tasks/task';
import {
  TaskEditDialogComponent
} from 'projects/desktop/src/app/modules/home-page/view/home-board/dash-board-main-block/task-column/task-edit-dialog/task-edit-dialog.component';
import {environment} from 'projects/desktop/src/environments/environment';
import {debounceTime, tap, filter} from 'rxjs/operators';
import {ShortTask} from 'projects/desktop/src/app/modules/home-page/data/tasks/short-task';
import {TasksService} from 'projects/desktop/src/app/modules/home-page/data/tasks/tasks.service';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {forkJoin, Subject, Subscription} from 'rxjs';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {DeviceDetectorService} from 'ngx-device-detector';
import {HttpEventType, HttpResponse} from '@angular/common/http';
import {ProjectFile} from 'projects/app-misc/src/app/modules/project-misc/data/project/project-file';
import {MiscSnackBarService} from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {
  ShortTasksListDialogComponent
} from 'projects/desktop/src/app/modules/home-page/view/home-board/dash-board-main-block/task-column/short-tasks-list-dialog/short-tasks-list-dialog.component';
import {
  ProjectActivityService
} from '../../../data/project/activity/project-activity.service';

@Component({
  selector: 'app-checklist-block',
  templateUrl: './checklist-block.component.html',
  styleUrls: ['./checklist-block.component.scss'],
  providers: [DeviceDetectorService]
})
@RxJSUnsubscribe
export class ChecklistBlockComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

  @Input()
  checkLists: TrelloChecklist[];

  @Input()
  projectId: number;

  @Input()
  projectName: string;

  deleteChecklistIds = [];
  idsToDelete = [];
  editItem = -1;

  checkListForAdd = -1;

  activeIndexes: number[] = [0, 2];

  currentUser: User;
  users: User[];

  tags: SelectItem[];

  trackEntityById = trackEntityById;

  loadingSpinnerId: number;

  toggleOrders = false;
  idsToOrder = [];
  checkItemsOrders: TrelloCheckItem[] = [];

  collapsedIds = [];

  isMobile: boolean;
  serviceDep: boolean;
  choosenCheckItem: TrelloCheckItem;
  wsSub1: Subscription;
  wsSub2: Subscription;

  permittedArrToClickOutside = [
    'cdk-drop-list',
    'middle-content',
    'p-accordion-content',
    'right-panel-block',
    'info-block',
    'status-block',
    'buttons-checklist-block'
  ]

  wsSub: Subscription;

  workOrderIdsSet = new Set();

  constructor(
    private miscSnackBarService: MiscSnackBarService,
    protected el: ElementRef,
    protected tasksService: TasksService,
    protected wsService: WsService,
    protected projectService: ProjectService,
    protected trelloService: TrelloService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ProjectWindowComponent>,
    protected viewContainerRef: ViewContainerRef,
    protected renderer: Renderer2,
    private userService: UserService,
    protected appStateQuery: AppStateQuery,
    protected confirmationService: ConfirmationService,
    private deviceDetector: DeviceDetectorService,
    private projectActivityService: ProjectActivityService
  ) {
    this.isMobile = this.deviceDetector.isMobile()
  }

  ngOnInit() {
    this.appStateQuery.currentUser$.subscribe(user => {
      this.currentUser = user

      if (this.currentUser) {
        this.serviceDep = !!this.currentUser.roles.find(role => role.name === 'Service Department')
      }
    })

    this.userService.getAllUsers().subscribe(users => {
      users.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      })
      this.users = users
    })

    this.trelloService.getTags().subscribe(tags => {
      this.tags = tags.map(tag => {
        return {
          label: tag.title,
          value: {
            id: tag.id,
            name: tag.name,
            color: tag.color,
            pos: tag.pos
          }
        };
      });
    })

    this.fillCollapsed();

    this.wsSub1 = this.wsService
      .listenUntilDestroyed<WsUpdateResponce<TrelloCheckItem>>('/topic/update/model.trello.TrelloCheckItem', this)
      .pipe(
        tap(updateInfo => {
          updateInfo.entity.checklist = this.checkLists.find(checklist => checklist.id === updateInfo.entity.checklist.id)
        }),
        filter(updateInfo => {
          return !!updateInfo.entity.checklist
        }),
        debounceTime(50)
      )
      .subscribe(updateInfo => {
        if (updateInfo.action === 'CREATE') {
          const foundedList = this.checkLists.find(checklist => checklist.id === updateInfo.entity.checklist.id)
          if (typeof updateInfo.entity.name !== 'undefined') {
            const existingItem = foundedList.checkItems.find(checkitem => checkitem.id === updateInfo.entity.id)

            if (!existingItem) {
              foundedList.checkItems.push(updateInfo.entity)
            }

            this.updatePunchlist();
          }

        }

        if (updateInfo.action === 'UPDATE') {
          const foundedCItem = updateInfo.entity.checklist.checkItems.find(item => item.id === updateInfo.entity.id)
          if (foundedCItem) {
            if (typeof updateInfo.entity.state !== 'undefined') {
              foundedCItem.ready = updateInfo.entity.state === 'complete';
            }
            if (typeof updateInfo.entity.name !== 'undefined') {
              foundedCItem.name = updateInfo.entity.name;
            }
          }

        }

        if (updateInfo.action === 'DELETE') {
          const foundedCItem = updateInfo.entity.checklist.checkItems.find(item => item.id === updateInfo.entity.id)
          if (foundedCItem) {
            const index = updateInfo.entity.checklist.checkItems.indexOf(foundedCItem, 0);
            if (index > -1) {
              updateInfo.entity.checklist.checkItems.splice(index, 1);

              this.updatePunchlist();
            }
          }

        }
      })

    this.trelloService.checkItemLoading$.subscribe(emit => {
      this.loadingSpinnerId = emit
    })

  }

  @HostListener('document:mousedown', ['$event'])
  clickout(event) {
    const clickedClassLists = (event.target.classList as DOMTokenList)

    if (this.permittedArrToClickOutside.includes(clickedClassLists[0])) {
      const newItemArea = document.getElementsByClassName('add-new-punch-item-area')[0];
      const files = document.getElementsByClassName('checkitem-file');
      if (newItemArea) {
        const textArea = newItemArea as HTMLTextAreaElement

        if (!textArea.value && !files.length) {
          this.onEditBlockClosed()
        }
      } else {
        this.onEditBlockClosed()
      }
    }
  }

  fillCollapsed() {
    if (this.checkLists[0]) {
      this.checkLists[0].checkItems.forEach(checkItem => {
        if (checkItem.taskDto && checkItem.taskDto.checkitemsCompleted >= checkItem.taskDto.checkitemsTotal && checkItem.taskDto?.checkitemsTotal > 2) {

          if (typeof checkItem.collapsed === 'undefined') {

            checkItem.collapsed = true;

            this.collapsedIds.push(checkItem.id)
          }
        }
      })
    }
  }

  toggleCollapse(checkitem: TrelloCheckItem) {
    checkitem.collapsed = !checkitem.collapsed

    if (checkitem.collapsed) {
      this.collapsedIds.push(checkitem.id)
    } else {
      const fItemIndex = this.collapsedIds.findIndex(item => item === checkitem.id)

      if (fItemIndex >= 0) {
        this.collapsedIds.splice(fItemIndex, 1)
      }
    }
  }

  emitCollapseOff(checkItemId: number) {

    const founded = this.checkLists[0].checkItems.find(item => item.id === checkItemId)

    if (founded) {
      founded.collapsed = false;

      const fItemIndex = this.collapsedIds.findIndex(item => item === checkItemId)

      if (fItemIndex >= 0) {
        this.collapsedIds.splice(fItemIndex, 1)
      }
    }
  }


  hideAccord(checklist: TrelloChecklist) {
    let count = 0;
    checklist.checkItems.forEach(item => {
      if (item.ready) {
        count++;
      }
    })
    if (count === checklist.checkItems.length && checklist.checkItems.length > 0) {
      return 1;
    } else {
      return 0;
    }
  }

  countPunchlist(checklist: TrelloChecklist) {
    let count = 0;
    checklist.checkItems.forEach(item => {
      if (item.ready) {
        count++;
      }
    })
    return count + '/' + checklist.checkItems.length;
  }

  toggleReady(checkItem: TrelloCheckItem) {

    checkItem.ready = !checkItem.ready

    this.projectService
      .saveCheckItem({
        id: checkItem.id,
        ready: checkItem.ready
      })
      .subscribe(() => {
      })

    if (checkItem.ready && this.isMobile && this.serviceDep) {
      this.attachPhoto(checkItem)
    }

  }

  attachPhoto(checkItem: TrelloCheckItem) {
    this.confirmationService.confirm({
      header: 'Attach Photo',
      message: `Would you like to attach photo?`,
      dismissableMask: true,
      icon: 'pi pi-paperclip',
      accept: () => {
        const input = this.el.nativeElement.getElementsByClassName('mobile-photo-input')[0] as HTMLInputElement
        if (input) {
          input.click()
          this.choosenCheckItem = checkItem
        }
      }
    });
  }

  onFileSelected(event) {
    const file = event.target.files[0] as File

    this.trelloService.checkItemLoading$.next(this.choosenCheckItem.id);

    this.trelloService.uploadFile([file], this.choosenCheckItem.id).subscribe(httpEvent => {
      if (httpEvent.type === HttpEventType.Response) {
        const projectFiles = (httpEvent as HttpResponse<ProjectFile[]>).body;
        this.choosenCheckItem.files = this.choosenCheckItem.files.concat(projectFiles)
        this.trelloService.checkItemLoading$.next(-1)
      }
    }, () => {
      this.trelloService.checkItemLoading$.next(-1)
    })
  }

  toggleDeleteChecklist(event: any, checkList: TrelloChecklist) {
    event.stopPropagation();
    if (this.deleteChecklistIds.includes(checkList.id)) {
      const index = this.deleteChecklistIds.indexOf(checkList.id, 0);
      this.deleteChecklistIds.splice(index, 1)
    } else {
      this.deleteChecklistIds.push(checkList.id)
    }
  }

  editCheckItem(checkListId: number, checkItemid: number) {
    this.editItem = checkItemid;
    this.checkListForAdd = checkListId;
  }

  addCheckItem(checkList: TrelloChecklist) {
    this.editItem = -2;
    this.checkListForAdd = checkList.id;
  }

  addToOrder() {
    const dialogRef = this.dialog.open(ShortTasksListDialogComponent, {
      data: {
        projectId: this.projectId,
        checkItemsIds: this.idsToOrder
      },
      disableClose: false,
      panelClass: 'unresolved-list-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (Task.prototype.isPrototypeOf(result)) {
        const resultTask = result as Task;

        const punchlist = this.checkLists.find(check => check.name === environment.trelloPunchCheckListName)
        let nullIndex = 0;

        this.idsToOrder.forEach(id => {
          const foundedItemIndex = punchlist.checkItems.findIndex((item, index) => {
            if (item.taskDto === null) {
              nullIndex = index;
            }
            return item.id === id;
          })

          if (foundedItemIndex >= 0) {
            punchlist.checkItems.splice(foundedItemIndex, 1)
          }

        })


        const fTask = punchlist.checkItems.find(item => item.taskDto && item.taskDto.id === resultTask.id)

        fTask.taskDto.checkItems = resultTask.checkitems

        this.idsToOrder = [];
        this.checkItemsOrders = [];

        this.toggleOrders = false;
        this.updatePunchlist()
      }
    })
  }

  deleteCheckItem(checkItem: TrelloCheckItem, checkList: TrelloChecklist) {
    this.idsToDelete.push(checkItem.id)

    this.trelloService.deleteCheckItem(checkItem.id).subscribe(() => {
      const index = checkList.checkItems.indexOf(checkItem, 0);
      if (index > -1) {
        checkList.checkItems.splice(index, 1);
      }
      this.onEditBlockClosed()

      if (this.idsToOrder.includes(checkItem.id)) {
        const fIndex = this.idsToOrder.indexOf(checkItem.id, 0);
        this.idsToOrder.splice(fIndex, 1)
        this.checkItemsOrders.splice(fIndex, 1)
      }

      const deleteindex = this.idsToDelete.indexOf(checkItem.id, 0);
      this.idsToDelete.splice(deleteindex, 1)
    }, error => {
      this.onEditBlockClosed()
      this.miscSnackBarService.openErrorSnackBar(error.message)
    })
  }

  onEditBlockClosed() {
    this.editItem = -1;
    this.checkListForAdd = -2;
  }

  onUpdateItem(event: TrelloCheckItem, checkList: TrelloChecklist) {
    const foundedItem = checkList.checkItems.find(item => item.id === event.id)
    foundedItem.name = event.name;
    foundedItem.mentions = event.mentions;
    foundedItem.tags = event.tags.sort((taga, tagb) => taga.type.pos - tagb.type.pos)
    this.onEditBlockClosed()
  }

  showLoadingSpinner(event: number) {
    this.loadingSpinnerId = event;
  }

  // openPdfPreview(): void {
  // 	// this.sendData.emit(this.currentUser)
  // 	const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
  // 		data: {
  // 			dialogHeader: this.project.name,
  // 			link: '/pdf/punch-list?id=' + this.project.id
  // 		},
  // 		disableClose: true,
  // 		panelClass: 'pdf-preview-dialog'
  // 	});
  // 	cpDialogRef.afterOpened().subscribe(() => {
  // 		this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'none')
  // 	})
  // 	cpDialogRef.afterClosed().subscribe(() => {
  // 		this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'flex')
  // 	})
  // }

  openTasks(event, checkItemId: number) {
    event.stopPropagation();

    this.dialog.open(TasksListDialogComponent, {
      data: {
        entityId: checkItemId,
        clazz: 'CHECKITEM_TASK'
      },
      panelClass: 'tasks-list-dialog',
      disableClose: false
    });
  }

  checkListDropped(event: CdkDragDrop<string[]>, checklist: TrelloChecklist) {
    moveItemInArray(checklist.checkItems, event.previousIndex, event.currentIndex);
    this.trelloService.moveCheckItem({
      id: checklist.checkItems[event.currentIndex].id,
      pos: event.currentIndex
    }).subscribe(() => {

    }, () => {
      console.log(`Something went wrong, can't move checkitem`)
    })
  }

  toggleTag(event, tag: CheckItemHeadTag) {
    event.stopPropagation();

    if (tag.name === 'Amount' && !this.currentUser.adminNSuperV) {

    } else {
      tag.ready = !tag.ready
      this.trelloService
        .toggleTag({
          id: tag.id,
          ready: tag.ready
        })
        .subscribe(() => {
        }, () => {
          tag.ready = !tag.ready
        })
    }

  }

  stopDrag() {
  }

  ngOnDestroy() {
    if (this.wsSub1) {
      this.wsSub1.unsubscribe()
      this.wsSub1 = null;
    }

    if (this.wsSub2) {
      this.wsSub2.unsubscribe()
      this.wsSub2 = null;
    }
  }

  toggleWorkOrders() {
    this.toggleOrders = !this.toggleOrders;

    this.idsToOrder = [];
    this.checkItemsOrders = [];

    const punchlist = this.checkLists.find(check => check.name === environment.trelloPunchCheckListName)
    punchlist.checkItems.forEach(item => {
      item.workOrder = false;
    })
  }


  createWorkOrder() {
    const tempData = {
      checkitemIds: this.idsToOrder,
      checkitems: this.checkItemsOrders.reverse(),
      clazz: 'SERVICE_ORDER_TASK'
    } as Task

    const dialogRef = this.dialog.open(TaskEditDialogComponent, {
      data: {
        task: tempData,
        buttonLabel: 'Create',
        taskType: 'order',
        projectId: this.projectId,
        projectName: this.projectName
      },
      panelClass: 'task-edit-dialog',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {

      if (Task.prototype.isPrototypeOf(result)) {
        const resultTask = result as Task;

        const punchlist = this.checkLists.find(check => check.name === environment.trelloPunchCheckListName)
        let nullIndex = 0;

        this.idsToOrder.forEach(id => {
          const foundedItemIndex = punchlist.checkItems.findIndex((item, index) => {
            if (!item.taskDto && nullIndex === 0) {
              nullIndex = index;
            }
            return item.id === id;
          })

          if (foundedItemIndex >= 0) {
            punchlist.checkItems.splice(foundedItemIndex, 1)
          }

        })
        const punchOrder = {
          id: resultTask.id,
          name: resultTask.text,
          ready: false,
          state: 'incomplete',
          files: [],
          mentions: [],
          tags: [],
          tagTypes: [],
          pos: 0,
          tasksDone: 0,
          tasksTotal: 0,
          taskDto: {
            id: resultTask.id,
            assignedUserName: resultTask.assignedUser.name,
            authorName: resultTask.author.name,
            checkitemsCompleted: resultTask.checkitemsCompleted,
            checkitemsTotal: resultTask.checkitemsTotal,
            checkItems: resultTask.checkitems,
            created: resultTask.created,
            deadline: resultTask.deadline,
            projectId: resultTask.project.id,
            projectName: resultTask.project.name,
            text: resultTask.text,
            isWorkOnSite: resultTask.isWorkOnSite,
            number: resultTask.number,
            clazz: resultTask.clazz
          }

        } as TrelloCheckItem;

        punchlist.checkItems.splice(nullIndex, 0, punchOrder)

        this.idsToOrder = [];
        this.checkItemsOrders = [];

        this.toggleOrders = false;
        this.updatePunchlist()
      }
    });
  }

  countWorkOrderTasks() {
    // if (punchlist) {
    // 	this.idsToOrder.forEach(id => {
    // 		const foundedItem = punchlist.checkItems.find(item => item.id === id)

    // 		if (foundedItem) {
    // 			foundedItem.workOrder = false

    // 			if (foundedItem.workOrderTasks) {
    // 				let foundedOrder = foundedItem.workOrderTasks.find(order => order.id === result.id)
    // 				if (foundedOrder) {
    // 					foundedOrder = (result as Task)
    // 				}
    // 			}
    // 		}

    // 	})
    // }
  }

  toggleWorkOrder(checkItem: TrelloCheckItem) {
    checkItem.workOrder = !checkItem.workOrder

    if (this.idsToOrder.includes(checkItem.id)) {
      const index = this.idsToOrder.indexOf(checkItem.id, 0);
      this.idsToOrder.splice(index, 1)
      this.checkItemsOrders.splice(index, 1)
    } else {
      this.idsToOrder.push(checkItem.id)
      this.checkItemsOrders.push(checkItem)
    }
  }

  toggleWorkOrderForTask(event: any, checkItem: TrelloCheckItem) {
    const taskCheckItem = event.checkItem;
    taskCheckItem.workOrder = event.selected;

    if (this.idsToOrder.includes(taskCheckItem.id)) {
      const index = this.idsToOrder.indexOf(taskCheckItem.id, 0);
      this.idsToOrder.splice(index, 1);
      this.checkItemsOrders.splice(index, 1);
    } else {
      this.idsToOrder.push(taskCheckItem.id);
      this.checkItemsOrders.push(taskCheckItem);
    }
  }


  editTask(event, checkItem: TrelloCheckItem) {
    event.stopPropagation();

    const dialogRef = this.dialog.open(TaskEditDialogComponent, {
      data: {
        task: checkItem.taskDto,
        buttonLabel: 'Save'
      },
      panelClass: 'task-edit-dialog',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(close => {
      this.workOrderIdsSet = new Set();
      this.idsToOrder.forEach((id => {
        this.workOrderIdsSet.add(id)
      }))


      if (close === 'DELETE') {
        const idToDelete = this.checkLists[0].checkItems.findIndex(item => item.id === checkItem.taskDto.id)
        if (idToDelete >= 0) {
          this.checkLists[0].checkItems.splice(idToDelete, 1);

          if (checkItem.taskDto.clazz === 'SERVICE_ORDER_TASK') {
            this.removeActivity(idToDelete);
          }

          this.updatePunchlist()
        }
      } else {
        forkJoin([this.tasksService.getShortTask(checkItem.taskDto.id), this.trelloService.getGroupedPunchList(this.projectId)]).subscribe(result => {
          const resultList = result[1];

          resultList.checkItems.forEach(item => {
            item.tags.sort((taga, tagb) => taga.type.pos - tagb.type.pos)
          })

          this.checkLists[0] = resultList;

          resultList.checkItems.forEach(item => {
            if (item && item.taskDto) {
              this.fillName(item.taskDto)
              this.countProgress(item.taskDto);
            }

            if (this.collapsedIds.includes(item.id)) {
              item.collapsed = true;
            }
          })

          this.checkToggledCheckitemsForWorkOrder()
        })

      }
    })
  }

  updatePunchlist() {
    this.trelloService.getGroupedPunchList(this.projectId).subscribe(newList => {
      this.checkLists[0] = newList;

      this.checkLists[0].checkItems.forEach(item => {

        if (item && item.taskDto) {
          this.fillName(item.taskDto)
          this.countProgress(item.taskDto);
        }

        if (this.collapsedIds.includes(item.id)) {
          item.collapsed = true;
        }
      })

      this.checkToggledCheckitemsForWorkOrder()
    })
  }

  checkToggledCheckitemsForWorkOrder() {
    this.checkLists[0].checkItems.forEach(item => {
      if (this.workOrderIdsSet.has(item.id)) {
        item.workOrder = true
      }
    })
  }

  fillName(task: ShortTask) {
    let name = task.assignedUserName

    let letters = name.split(' ');
    if (letters.length > 1) {
      task.shortAssigned = letters[0] + ' ' + letters[1].split('')[0] + '.'
    } else {
      task.shortAssigned = letters[0];
    }

    name = task.authorName
    letters = name.split(' ');
    if (letters.length > 1) {
      task.shortAuthor = letters[0] + ' ' + letters[1].split('')[0] + '.'
    } else {
      task.shortAuthor = letters[0];
    }

  }

  countProgress(task: ShortTask) {
    task.progressBarNum = (task.checkitemsCompleted * 100) / task.checkitemsTotal;
    if (task.progressBarNum <= 33) {
      task.colorNum = 'low-progress';
    } else if (task.progressBarNum > 33 && task.progressBarNum <= 66) {
      task.colorNum = 'middle-progress';
    } else if (task.progressBarNum > 66 && task.progressBarNum <= 100) {
      task.colorNum = 'high-progress';
    }
  }

  fillNames(list: TrelloChecklist) {
    list.checkItems.forEach(item => {
      if (item.taskDto) {

        let name = item.taskDto.assignedUserName

        let letters = name.split(' ');
        if (letters.length > 1) {
          item.taskDto.shortAssigned = letters[0] + ' ' + letters[1].split('')[0] + '.'
        } else {
          item.taskDto.shortAssigned = letters[0];
        }

        name = item.taskDto.authorName
        letters = name.split(' ');
        if (letters.length > 1) {
          item.taskDto.shortAuthor = letters[0] + ' ' + letters[1].split('')[0] + '.'
        } else {
          item.taskDto.shortAuthor = letters[0];
        }
      }
    })

  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

  removeActivity(activityId: number) {
    this.projectActivityService.projectActivityEmitter.emitRemove(activityId);
  }

}
